import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    msystax: [],
    vwcmsttorihikisakigetnyukinsaki: [],
    vwcmsttorihikisakigetshiharaisaki: [],
    vwcmsttorihikisakigetseikyusaki: [],
    vwcmstkengengroup01: [],
    mstjinin: [],
    mstmenkyosho: [],
    mstjishaginkokoza: [],
    msttorihikisaki: [],
    msteigyosho: [],
    msyskubun: [],
    msyskubunshubetsushurui: [],
    msthacchakuchi: [],
    mstshubetsu: [],
    mstkihonjoho: [],
    mstkingaku: [],
    msthinmei: [],
    mstsharyo: [],
    msysmessage: [],
    mstfaseimage: {},
    mstkengen: [],
    mstkengengroup: {},
    msysgamenseni: [],
    msyskino: [],
    msysmenu: [],
    msysmenudetail: [],
    msysmenuoshirase: [],
    msysinputsave: [],
    msyssystemconfig: [],
    msttokuisaki: [],
    mstnyukinsaki: [],
    msthacchusaki: [],
    mstseikyusaki: [],
    mstshiharaisaki: [],
    mstaddress: [],
    mstshuhaichiku: [],
    vwcmstchimei: [],
    mstbumon: [],
    mstfileformatkihon: [],
    vwcmsteigyoshojininlist: [],
    vwcmstsharyo: [],
    vwcmstkengengroup: [],
    msthaishahyo: [],
    mstdigitakojoho: [],
    vwcmsthaishahyosharyo: [],
    vwcd2mstd0370: [],
    vwcd2mstd0460: [],
    mstetcriyoujoho: [],
    mstusersettings: [],
    mstnenpicategory: [],
    mstxlsimportmapping: [],
    mstxlstemplatekihon: [],
    authjwttoken: '',
    certificateMasters: [
      'authjwttoken',
      'mstfaseimage',
      'mstkengen',
      'mstkengengroup',
      'msysgamenseni',
      'msyskino',
      'msysmenu',
      'msysmenudetail',
      'msysmenuoshirase',
      'msysinputsave',
      'msysmessage',
      'msystax',
      'vwcmstkengengroup',
      'msyskubun',
      'mstshubetsu',
      'msyssystemconfig',
      'mstusersettings',
      'mstkihonjoho'
    ]
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
